<template>
  <div class="jobs-nav-main" :class="[border ? 'border' : '', link.length===1 ? 'hide-border' : '' ]">
    <a
      v-for="(item, index) in link"
      :key="index"
      :class="['jobs-nav-menu', item.active ? 'active' : '']"
      :href="item.url"
       >
      {{ item.name }}
    </a>
  </div>
</template>
<script>
/**
 * auth: wangjunfa
 * updated: 2020-5-10
 */
export default {
  name: 'JobsNav',
  props: {
    // nav 数组 默认[] [{url: '', target: '_blank', name: '', active: false}]
    link: {
      type: Array,
      default() {
        return [];
      }
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    change(item) {
      console.log(item,this.link)
      item.active=true
      this.link[0].active=false
    }
  }
}
</script>
<style lang="scss" scoped>
.jobs-nav-main {
  width: 100%;
  line-height: 30px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  border-radius: 2px;
  margin-bottom: 29px;
  .jobs-nav-menu {
    width: 90px;
    cursor: pointer;
    font-size: 18px;
    color: #9C9C9C;
    margin-right: 24px;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: #404040;
    }
    &.active {
      color: #404040;
      font-size: 22px;
      font-weight: bold;
      &::after {
        content: "";
        display: block;
        width: 20px;
        height: 3px;
        background: #FF6644;
        position: absolute;
        bottom: -9px;
        left: 50%;
        margin-left: -10px;
      }
    }
  }
  &.hide-border{
    margin-bottom: 24px;
    .jobs-nav-menu.active::after{
      display: none;
    }
  }
}
</style>